import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { luxColors, DNAIcon } from '../..';
var ICON_NAME;
(function (ICON_NAME) {
    ICON_NAME["information"] = "information";
    ICON_NAME["success"] = "checkbox-marked-circle";
    ICON_NAME["warning"] = "alert";
    ICON_NAME["error"] = "alert-circle";
    ICON_NAME["loading"] = "timer-sand-empty";
    ICON_NAME["download"] = "download";
})(ICON_NAME || (ICON_NAME = {}));
/*
  Note: inline styles are used rather than theming due where the Toast provider is loaded
*/
const styles = StyleSheet.create({
    wrapper: {
        flex: 1,
        flexDirection: 'row',
        paddingTop: 10,
        paddingLeft: 10,
        paddingBottom: 10,
        paddingRight: 8,
        backgroundColor: luxColors.info.primary,
        alignItems: 'flex-start',
    },
    icon: {
        width: 20,
        height: 20,
    },
    title: {
        flex: 1,
        fontSize: 13,
        lineHeight: 24,
        marginRight: 12,
        marginLeft: 12,
        alignSelf: 'flex-start',
        fontWeight: 'bold',
    },
    description: {
        fontSize: 12,
        lineHeight: 16,
        marginRight: 12,
        marginLeft: 12,
        color: 'rgb(109, 109, 109)',
    },
    copyButton: {
        alignSelf: 'center',
        color: 'rgb(68, 162, 218)',
        lineHeight: 24,
        fontSize: 13,
        fontWeight: 'bold',
        marginRight: 8,
        marginLeft: 8,
    },
    content: {
        flex: 1,
        paddingTop: 0,
    },
});
const GenericToast = ({ width, status, title, actionConfig, description }) => {
    const wrapperStyle = [styles.wrapper, { width: width }];
    const iconStyle = [styles.icon, { color: luxColors.toastIcon[status] }];
    return (<View testID="toast-container" style={wrapperStyle}>
      <DNAIcon testID={`icon-${ICON_NAME[status]}`} name={ICON_NAME[status]} style={iconStyle}/>
      <View style={styles.content}>
        <Text testID="toast-message" style={styles.title}>{title}</Text>
        {description && <Text style={styles.description}>{description}</Text>}
      </View>
      {actionConfig &&
            <TouchableOpacity style={{ backgroundColor: 'Transparent' }} onPress={actionConfig.callback}>
            <View>
              <Text testID="copy-shared-link" style={styles.copyButton}>
                {actionConfig.actionTitle}
              </Text>
            </View>
          </TouchableOpacity>}
    </View>);
};
export default GenericToast;
//# sourceMappingURL=GenericToast.js.map